import { Flex } from '@vimeo/bokeh';
import { ModuleHeader as HeaderComponent } from '@vimeo/clip-ui/components/ModuleHeader';
import { SearchComments } from '@vimeo/comments-ui';

type ModuleHeaderProps = {
  onClose?: VoidFunction;
  text: string;
  count?: number;
  searchInputRef?: React.RefObject<HTMLDivElement | null>;
  showCommentSearchBar?: boolean;
  updateCommentSearchQuery?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onCloseSearch?: () => void;
};

export const ModuleHeader = ({
  onClose,
  text,
  count,
  children,
  searchInputRef,
  showCommentSearchBar,
  updateCommentSearchQuery,
  onCloseSearch,
}: React.PropsWithChildren<ModuleHeaderProps>) => {
  if (showCommentSearchBar) {
    return (
      <Flex align="center" justify="space-between" p="lg">
        <SearchComments
          updateCommentSearchQuery={updateCommentSearchQuery}
          onCloseSearch={onCloseSearch}
          searchInputRef={searchInputRef}
        />
      </Flex>
    );
  }

  return (
    <HeaderComponent onClose={onClose} text={text} secondaryText={count}>
      {children}
    </HeaderComponent>
  );
};
